import { render, staticRenderFns } from "./TkPulldown.vue?vue&type=template&id=21fb9652&scoped=true&"
import script from "./TkPulldown.vue?vue&type=script&lang=js&"
export * from "./TkPulldown.vue?vue&type=script&lang=js&"
import style0 from "./TkPulldown.vue?vue&type=style&index=0&id=21fb9652&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fb9652",
  null
  
)

export default component.exports